import { useEffect } from 'react';
import Thread from '../thread/Thread';

const Chimes = ({ chimeData, setReplyOpen, authorPrincipal, userSettings,
    playList, setPlayList, openMediaPlayer, setOpenMediaPlayer,
    selectedChimeTx, setSelectedChimeTx, mediaCurrentTime, setMediaCurrentTime
}) => {

    useEffect(() => {
    }, [chimeData])

    return (
        <>
            {chimeData && chimeData.map(({ base, hex }, i) => {
                return <Thread baseTxId={base} hex={hex} setReplyOpen={setReplyOpen} profilePrincipal={authorPrincipal} index={i} key={i} userSettings={userSettings}
                    playList={playList} setPlayList={setPlayList} openMediaPlayer={openMediaPlayer} setOpenMediaPlayer={setOpenMediaPlayer}
                    selectedChimeTx={selectedChimeTx} setSelectedChimeTx={setSelectedChimeTx} mediaCurrentTime={mediaCurrentTime} setMediaCurrentTime={setMediaCurrentTime}
                />
            })}
        </>
    )
}

export default Chimes;